import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { COUNTRIES } from './bibliothequeConstants';

const BibliothequeImportDialog = ({
  open, onOpenChange,
  importFile, setImportFile,
  importYear, setImportYear,
  importCountry, setImportCountry,
  autoCreateCalendar, setAutoCreateCalendar,
  handleImport,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{t("holidayLibraryComponents.import.title")}</DialogTitle>
        <DialogDescription>{t("holidayLibraryComponents.import.description")}</DialogDescription>
      </DialogHeader>
      <form onSubmit={handleImport}>
        <div className="grid gap-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="import-file">{t("holidayLibraryComponents.import.file")}</Label>
            <Input
              id="import-file"
              type="file"
              accept=".csv"
              onChange={(e) => setImportFile(e.target.files[0])}
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="import-year">{t("holidayCommon.fields.year")} *</Label>
              <Input
                id="import-year"
                type="number"
                value={importYear}
                onChange={(e) => setImportYear(parseInt(e.target.value))}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="import-country">{t("holidayCommon.fields.country")} *</Label>
              <Select value={importCountry} onValueChange={setImportCountry}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  {COUNTRIES.map((country) => (
                    <SelectItem key={country} value={country}>{country}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <Checkbox
              id="auto-create-calendar"
              checked={autoCreateCalendar}
              onCheckedChange={setAutoCreateCalendar}
            />
            <Label htmlFor="auto-create-calendar" className="cursor-pointer">
              {t("holidayLibraryComponents.import.autoCreate")}
            </Label>
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              onOpenChange(false);
              setImportFile(null);
            }}
          >
            {t("holidayCommon.cancel")}
          </Button>
          <Button type="submit">{t("holidayCommon.import")}</Button>
        </DialogFooter>
      </form>
    </DialogContent>
    </Dialog>
  );
};

export default BibliothequeImportDialog;
